<template>
  <div id="questionnaireAnswer" v-if="divVisible">
    <b>評価結果一覧画面</b><br/><br/>

    <table class="table icon">
      <tr>
        <td>直近評価結果一覧を参照いただきます。 <br><B   v-if="user.userType == '1' || user.userType == '3' " style="color:red;">横断評価済み状態は最新月のみで判断しております、その前の月は評価してない場合、評価リングで追加評価できます</B></td>
      </tr>
    </table><br/>

    <form onsubmit="return false;">
      <div class="bootstrap-table fixed-table-container" style="margin-bottom:10px;width: 150%;">
        <table id="rptHeader" class="table table-striped">
          <thead>

            <tr v-for="(head, index) in heads" v-bind:key="'head' + index">
              <td v-if="user.userType == '1' || user.userType == '3' " class="h5" style="position: sticky; top: 0px;  background: white;">
                  横断評価
              </td>
              <td style="position: sticky; top: 0px;  background: white;">{{ head.evaluateeMemberID }}</td>
              <td style="position: sticky; top: 0px;  background: white;">{{ head.optionScoreSum }}</td>
              <td v-for="(headOptionScore, index2) in head.optionScores" v-bind:key="'headOptionScore' + index2" style="position: sticky; top: 0px;  background: white;">{{ headOptionScore.optionScore }}<br> {{ headOptionScore.optionScoreOriginal }}</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" v-bind:key="'row' + index">
              <td v-if="user.userType == '1' || user.userType == '3' " class="h5" style="white-space: nowrap;">
                
                    <template v-if="row.answerDataCount >0 ">横断<router-link :to="{ name: 'questionnaire', params: { backScreenId: 'questionnaireAnswer', directEvalFlg:'1', evaluateeMemberID: row.evaluateeMemberID  } }">評価</router-link>済</template>
                    <template v-else>
                    <router-link :to="{ name: 'questionnaire', params: { backScreenId: 'questionnaireAnswer', directEvalFlg:'1', evaluateeMemberID: row.evaluateeMemberID  } }">横断評価</router-link>
                    </template>
               
              </td>
              <td style=" white-space: nowrap;">
                <div><h4>{{ row.evaluateeMemberName }}</h4></div>
              </td>
              <td>{{ row.optionScoreSum }}</td>
              <td v-for="(rowOptionScore, index2) in row.optionScores" v-bind:key="'rowOptionScore' + index2">
                <div v-if="user.userType == '1' || user.userType == '3' ">
                  <router-link :to="{ name: 'questionnaireAnswerDetails', params: { questionnaireID: rowOptionScore.questionnaireID, evaluateeMemberID: row.evaluateeMemberID } }">{{ rowOptionScore.optionScoreOriginal }}</router-link>
                </div>
                <div v-if="user.userType != '1' && user.userType != '3' ">
                  {{ rowOptionScore.optionScoreOriginal }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div><br/>
      <button @click="$router.push({ name: 'mains', params: { } });" class="btn-mid" style="width:250px;">メイン画面へ</button><br/>
    </form>
  </div>
</template>

<script>
  export default {
    name: "questionnaireAnswer",
    data() {
      return {
          divVisible: false,
          user:  { memberID: '', memberName: '', userType: '', deleteFlg: '' },
          heads: [ { evaluateeMemberID: '', evaluateeMemberName: '', optionScoreSum: '', optionScores: [ { questionnaireID: '', optionScore: '', optionScoreOriginal: '' } ] } ],
          rows:  [ { evaluateeMemberID: '', evaluateeMemberName: '', optionScoreSum: '', optionScores: [ { questionnaireID: '', optionScore: '', optionScoreOriginal: '' } ] } ],
      }
    },
    mounted() {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = '/static/js/common.js?v=17';
      document.body.appendChild(s);
      this.init();
    },
    methods: {
      init: function () {
        var self = this;

        // サーバ側処理呼び出す
        new Promise(function (request, response) {
          var data = self.$route.params;
          common.getAxios().post(process.env.API_URL +"/api/QuestionnaireAnswerInit", data)
            .then(function (res) {
              if (res.data) {
                self.user = res.data.user;
                self.heads = res.data.heads;
                self.rows = res.data.rows;
                self.divVisible = true;
              }
            })
            .catch(function (err) {
              alert(err);
            });
        });

      },
    },

  };
</script>



// WEBPACK FOOTER //
// questionnaireAnswer.vue?6fdba990